import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

// https://www.npmjs.com/package/react-datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";

function NuevaPatente(props) {
	const { guardar, setQueMostrar } = props

	registerLocale('es', es)

	const datosInicial = {
		anho: '',
		solicitadas: false,
		otorgadas: false
	}
	const [datos, setDatos] = useState(datosInicial)
	const [erroresValidacion, setErroresValidacion] = useState({})

	const handleClose = () => {
		setQueMostrar('')
		setDatos(datosInicial)
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
			fechaCreacion: new Date()
		}

		if (validarDatos()) {
			guardar(data)
			handleClose()
		}
	}

	const validarDatos = () => {
		const camposRequeridos = ['anho']
		const nuevosErrores = {}

		camposRequeridos.forEach(campo => {
			if (datos[campo].trim() === '') {
				nuevosErrores[campo] = 'Este es un campo requerido'
			} else {
				nuevosErrores[campo] = null
			}
		})

		const errores = { ...erroresValidacion, ...nuevosErrores }

		setErroresValidacion(errores)

		return Object.keys(errores).filter(elem => errores[elem] !== null).length === 0
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const handleSeleccionDocumento = (files, cual) => {
		setDatos({ ...datos, [cual]: files[0] })
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Nueva patente" />
			<Offcanvas.Body id="nueva-patente">
				<h1>Campos de la patente</h1>
				<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="patente-anho">
										<FormLabel>Año</FormLabel>
										<Form.Control
											value={datos.anho}
											onChange={(e) => handleChange(e.target.value, 'anho')}
											type="number"
											isInvalid={erroresValidacion.anho}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.anho}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						<h3>Solicitadas</h3>
						<FileUpload
							title="Documento"
							accept=".pdf, .doc, .docx"
							buttonText="Elegir"
							buttonTextSingular="documento"
							updateFiles={(files) => { handleSeleccionDocumento(files, 'solicitadas') }}
						/>
						<div className="py-4 text-center">
							<div style={{ width: '80%', marginLeft: '10%', borderBottomWidth: 1, borderBottomStyle: 'dotted', height: 1 }}></div>
						</div>
						<h3>Otorgadas</h3>
						<FileUpload
							title="Documento"
							accept=".pdf, .doc, .docx"
							buttonText="Elegir"
							buttonTextSingular="documento"
							updateFiles={(files) => { handleSeleccionDocumento(files, 'otorgadas') }}
						/>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default NuevaPatente